module.exports = __webpack_public_path__ + "static/media/how-it-works-filters-2.610e7f91.png";